<div class="container-fluid px-0 bg-star min-height">
    <div class="container py-5">
    <div class="row">
        <div class="col-md-6 m-auto">
            <div class="box-design with-before">
                <div class="content-section">
                    <h5 class="mb-4">Payment Successfull</h5>
                    <p *ngIf="!showmsg">
                        Welcome to The Cheer Forge! Your account is ready to go.  We are so excited to have you here!<br/>
                        <a href="javascript:void(0)" (click)="click()">Click Here</a> to Login Now
                    </p>
                    <p *ngIf="showmsg">
                        Your subscription is updated suceessfully. We are so excited to have you here!<br/>
                        <a [routerLink]="['/video']">Click Here</a> to Check the latest videos.
                    </p>
                </div>
            </div>
        </div>
    </div>


</div>
</div>
